export default __webpack_public_path__ + "static/media/long-left-arrow.519fcf7a.png";